export default "__VITE_ASSET__eb242bc8__"